import { createStorageAtomFactory } from '@exodus/atoms';
const STORAGE_KEY = 'remoteConfigAtom';
const DEFAULT_VALUE = {};
const createRemoteConfigAtom = ({ storage }) => {
    const createStorageAtom = createStorageAtomFactory({ storage });
    return createStorageAtom({ key: STORAGE_KEY, defaultValue: DEFAULT_VALUE });
};
const remoteConfigAtomDefinition = {
    id: 'remoteConfigAtom',
    type: 'atom',
    factory: createRemoteConfigAtom,
    dependencies: ['storage'],
    public: true,
};
export default remoteConfigAtomDefinition;
